import { useMutation } from 'react-query-v5';
import { LOGIN_BASE_REQUEST } from '@sib/auth';
import { msalInstance } from '@sib/auth';
import { useAuthStore } from '@sib/auth';
import { tracking } from '@sib/tracking';
import { updateUserId } from '@spendbrain/common/utils';

export const useLogin = () => {
  const { setAccount } = useAuthStore();

  return useMutation({
    mutationFn: async () => {
      msalInstance.clearCache();
      const data = await msalInstance.loginPopup({
        ...LOGIN_BASE_REQUEST,
        prompt: 'select_account',
      });

      msalInstance.setActiveAccount(data.account);

      tracking.setUser({
        email: data.account.username || '',
        name: data.account.name || '',
      });
      setAccount(data.account);

      updateUserId();

      return data;
    },
  });
};
